export const modelsFieldsMap = {
  'ExclusionItems': {
    'objectType': 'specifics.type',
    'excludedItems': 'specifics.path',
    'modules': 'specifics.modules',
    'remarks': 'description',
    'inLists': 'inListsCount',
    'inPolicies': 'inPolicies',
    'addedOn': 'created.date',
  },
  'MaintenanceWindows': {
    'name': 'name',
    'type': 'type',
    'status': 'status',
    'allowChangeByOtherUsers': 'allowChangeByOtherUsers',
    'inPolicies': 'inPolicies',
    'lastEditedByFullName': 'lastEditedByFullName',
    'lastModified': 'lastModified',
    'specifics.installPatchesSettings.updateType.securityPatchesSettings.enabled': 'specifics.installPatchesSettings.updateType.securityPatchesSettings.enabled',
    'specifics.installPatchesSettings.updateType.nonSecurityPatchesSettings.enabled': 'specifics.installPatchesSettings.updateType.nonSecurityPatchesSettings.enabled',
    'specifics.installPatchesSettings.updateType.manuallyApprovedPatchesSettings.enabled': 'specifics.installPatchesSettings.updateType.manuallyApprovedPatchesSettings.enabled',
  },
};

export function getExclusionItemsRecords(response) {
  const data = response.data.map((item) => {
    return {
      id: item._id,
      objectType: item.specifics.type,
      excludedItems: item.specifics.path,
      modules: item.specifics.modules,
      remarks: item.description,
      inLists: item.inLists,
      addedOn: item.created ? item.created.date : null,
    };
  });

  return {
    data: data,
    total: response.total,
  };
}

export function getPayloadForReadRecords(request) {
  const limit = request.pageSize ? request.pageSize : 50;
  let page;

  if ('numRecordsToSkip' in request) {
    page = isNaN(request.numRecordsToSkip / limit) ? 1 : (request.numRecordsToSkip / limit) + 1;
  } else {
    page = request.pageNumber ? request.pageNumber : 1;
  }

  const dir = request.sortDirection ? request.sortDirection : null;
  const sort = request.sortColumnName && modelsFieldsMap['ExclusionItems'][request.sortColumnName] ? modelsFieldsMap['ExclusionItems'][request.sortColumnName] : null;

  const params: any = {
    page: page,
    limit: limit,
    filter: formatFilters(request.filters, modelsFieldsMap['ExclusionItems']),
    extraParams: request.extraParams,
  };

  if (sort && dir) {
    params.sort = sort;
    params.dir = dir;
  }
  return params;
}

export function formatFiltersDateAbsolute(fieldsMap, fieldValue, filterName) {
  return {
    minValue: {
      property: fieldsMap[filterName] + '[min]',
      value: new Date(fieldValue.absolute.fromTimestamp).toISOString(),
    },
    maxValue: {
      property: fieldsMap[filterName] + '[max]',
      value: new Date(fieldValue.absolute.toTimestamp).toISOString(),
    },
  };
}

export function formatFiltersDateRelative(fieldsMap, fieldValue, filterName) {
  let minValue;
  const maxValue = new Date().getTime();

  if (fieldValue.relative.lastNumDays === 1) {
    minValue = new Date(maxValue - (24 * 60 * 60 * 1000));
  } else if (fieldValue.relative.lastNumDays === 7) {
    minValue = new Date(maxValue - (7 * 24 * 60 * 60 * 1000));
  } else if (fieldValue.relative.lastNumDays === 30) {
    minValue = new Date(maxValue - (30 * 24 * 60 * 60 * 1000));
  }

  if (minValue === null) {
    return {};
  }

  return {
    minValue: {
      property: fieldsMap[filterName] + '[min]',
      value: new Date(minValue).toISOString(),
    },
    maxValue: {
      property: fieldsMap[filterName] + '[max]',
      value: new Date(maxValue).toISOString(),
    },
  };

}

export function formatFilters(filters, fieldsMap) {
  const formattedFilters: any = [];

  for (const obj in filters) {
    if (!filters.hasOwnProperty(obj)) {
      continue;
    }

    for (const filterName in filters[obj]) {
      if (!filters[obj].hasOwnProperty(filterName)) {
        continue;
      }

      const fieldValue: any = Object.values(filters[obj][filterName])[0];
      switch (true) {

        case (typeof fieldValue === "object" && !!fieldValue?.absolute):
          const { minValue:absoluteFilterMinValue, maxValue:absoluteFilterMaxValue } = formatFiltersDateAbsolute(fieldsMap, fieldValue, filterName);
          formattedFilters.push(absoluteFilterMinValue, absoluteFilterMaxValue);
          break;

        case (typeof fieldValue === "object" && !!fieldValue?.relative):
          const { minValue, maxValue } = formatFiltersDateRelative(fieldsMap, fieldValue, filterName);
          if (minValue && maxValue) {
            formattedFilters.push(minValue, maxValue);
          }
          break;

        case ((typeof fieldValue === 'string' ||  Array.isArray(fieldValue)) && !!fieldValue.length):
          formattedFilters.push({
            property: fieldsMap[filterName],
            value: fieldValue,
          });
          break

        default:
          break;
      }

    }
  }

  return formattedFilters;
}
